import { render } from "./WaveInfo.vue?vue&type=template&id=4a725ed0&scoped=true&ts=true"
import script from "./WaveInfo.vue?vue&type=script&lang=ts"
export * from "./WaveInfo.vue?vue&type=script&lang=ts"

import "./WaveInfo.vue?vue&type=style&index=0&id=4a725ed0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a725ed0"]])

export default __exports__